<template>
  <div>
    <el-card body-style="padding: 0;padding-right:2%;">
      <el-form ref="queryForm" :model="queryForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="用户名" prop="userName">
              <el-input v-model="queryForm.userName" placeholder="请输入用户名称"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="上级用户" prop="upBusinessUser">
              <el-input v-model="queryForm.upBusinessUser" placeholder="请输入上级用户"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="账号名称" prop="plateformAccountName">
              <el-input v-model="queryForm.plateformAccountName" placeholder="请输入名称"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="所属业务员" prop="businessUser">
              <el-input v-model="queryForm.businessUser" placeholder="请输入业务员"/>
            </el-form-item>
          </el-col>
          <!--<el-col :span="5">
            <el-form-item label="用户类型" prop="usertype">
              <el-select v-model="queryForm.usertype" clearable placeholder="请选择用户类型">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>-->
        </el-row>
        <el-row :gutter="20" style="margin-top: 15px;">
          <el-col :span="6">
            <el-form-item label="审核状态" prop="status">
              <el-select @change="statusChange" v-model="queryForm.status" clearable placeholder="请选择审核类型">
                <el-option
                    v-for="item in statusOptions"
                    :key="item.flag"
                    :label="item.value"
                    :value="String(item.value)"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台" prop="plateformName">
              <el-select v-model="queryForm.plateformName" clearable placeholder="请选择">
                <el-option
                    v-for="item in allShopTypes"
                    :key="item.value"
                    :label="item.shopType"
                    :value="item.shopType"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="4">
            <el-form-item>
              <el-button type="primary" size="small"
                         @click="submitQueryForm()" icon="el-icon-search">
                查询
              </el-button>
              <el-button type="primary" size="small" plain
                         @click="resetQueryForm()" icon="el-icon-refresh">
                重置
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card>
      <el-button type="primary" size="mini" style="margin: 0 0 10px 20px" icon="el-icon-warning-outline"
                 @click="handleReviewBatch">批量审核
      </el-button>
      <el-button type="danger" size="mini" style="margin: 0 0 10px 20px" icon="el-icon-warning-outline"
                 @click="handleDeleteBatch">批量删除
      </el-button>
      <el-table :data="tableData"
                border default-expand-all stripe
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                :max-height="tableHeight"
                style="width: 100%;margin-bottom: 20px;"
                ref="table"
                @selection-change="handleSelectionChange">
        <el-table-column label="全选" width="50" type="selection"/>
        <el-table-column prop="userId" label="用户ID" width="120">
          <!--<template slot-scope="scope">
            <span>{{ getStrEndWithNumbers(scope.row.userId) }}</span>
          </template>-->
        </el-table-column>
        <el-table-column prop="userName" label="用户名"/>
        <el-table-column prop="upBusinessUser" label="上级用户"/>
        <el-table-column prop="businessUser" label="业务员"/>
        <el-table-column prop="plateformAccountName" label="账号名称"/>
        <el-table-column label="账号数量">
          <template slot-scope="scope">
            <span>{{ scope.row.accountUsedNum }}/{{ scope.row.accountNumTotal }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="plateformImages" label="账号图片" width="100">
          <template slot-scope="scope">
            <el-image style="width: 100px; height: 100px;margin: 1%;"
                      :src="scope.row.plateformImages"
                      :preview-src-list="new Array(scope.row.plateformImages)"
                      lazy>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="plateformName" label="平台"/>
        <el-table-column prop="plateformStatusStr" label="状态"/>
        <el-table-column prop="isUsedStr" label="是否启用"/>
        <el-table-column prop="because" label="原因"/>
        <el-table-column prop="reviewTime" label="审核时间"/>
        <el-table-column prop="addTime" label="添加时间"/>
        <el-table-column prop="reviewOperation" label="账号审核操作人"/>
        <el-table-column prop="remarks" label="备注"/>
        <el-table-column label="操作" width="260" align="center">
          <template slot-scope="scope">
            <el-row>
              <el-col :span="12">
                <el-button plain size="mini" type="primary" v-if="!scope.row.isGrifter"
                           @click="uploadGifter(scope.$index, scope.row)">
                  上传骗子库
                </el-button>
                <el-button plain size="mini" type="danger" v-else @click="uploadGifter(scope.$index, scope.row)">
                  移除骗子信息
                </el-button>
              </el-col>
              <el-col :span="6">
                <el-button size="mini" type="danger" plain v-if="scope.row.isUsed"
                           @click="unEnableUser(scope.$index, scope.row)">
                  禁用
                </el-button>
                <el-button size="mini" type="primary" plain v-else
                           @click="unEnableUser(scope.$index, scope.row)">
                  开启
                </el-button>
              </el-col>
              <el-col :span="6" v-show="isShowAccessField(3)">
                <el-button size="mini" type="danger" plain
                           @click="deletedAccountInfo(scope.$index, scope.row)">
                  删除
                </el-button>
              </el-col>
            </el-row>
            <el-row style="margin-top: 5px;">
              <el-col :span="6">
                <el-button size="mini" type="primary" plain
                           @click="addRemarks(scope.$index, scope.row)">
                  备注
                </el-button>
              </el-col>
              <el-col :span="6">
                <el-button size="mini" type="primary" plain
                           @click="settingAccountInfo(scope.$index, scope.row)">
                  设置
                </el-button>
              </el-col>
              <el-col :span="6">
                <el-button size="mini" type="primary" plain
                           @click="reviewAccountInfo(scope.$index, scope.row)">
                  查看
                </el-button>
              </el-col>
              <el-col :span="6">
                <el-button size="mini" type="primary" plain
                           @click="accountReviewCurrentRow(scope.$index, scope.row)" v-show="scope.row.plateformStatusStr != '审核通过'">
                  审核
                </el-button>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          :page-sizes="[20, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.pageNum"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          @size-change="handlePageSizeChange"
          @current-change="handlePageNumChange"
          background
          style="float: right;margin-bottom: 10px">
      </el-pagination>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
      <el-form ref="dialogForm" :model="dialogForm" label-width="220px">
        <el-form-item label="备注">
          <el-input v-model="dialogForm.remarks" style="width: 50%;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitRemarks()" size="mini" type="primary">提交</el-button>
        <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="dialogSetTitle" :visible.sync="dialogSetFormVisible">
      <el-form ref="dialogSetForm" :model="dialogSetForm" label-width="80px">
        <div class="tableCls" style="margin-top: 15px;">
          <el-row>
            <el-col :span="24">
              <div style="background-color: #44b1eb; width: 100%;line-height: 33px;">
                账号信息<span style="margin: 1%;">[{{ plateformName }}]</span>
              </div>
            </el-col>
          </el-row>
          <el-row class="subLine" style="width: 100%;">
            <el-col :span="12">
              <el-form-item label="会员名" style="line-height: 33px;">
                <el-input v-model="dialogSetForm.plateformUsername" size="small"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="性别" style="line-height: 33px;">
                <el-radio-group v-model="dialogSetForm.plateformSex" @change="tackReviewChange">
                  <el-radio :label="true">男</el-radio>
                  <el-radio :label="false">女</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="subLine" style="width: 100%;" v-if="plateformName == '淘宝'">
            <el-col :span="12">
              <el-form-item label="淘气值" style="line-height: 33px;">
                <el-input v-model="dialogSetForm.taoValue" size="small"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="钻级" style="line-height: 33px;width: 100%;">
                <el-input type="number" v-model="dialogSetForm.diamondsLevel" size="small" style="width: 40%" @change="diamondsLevelChange"></el-input>
                <el-select v-model="dialogSetForm.accountLeave" clearable placeholder="请选择" size="small"
                           style="margin-left:1%;width: 40%" @change="selectedChange">
                  <el-option
                      v-for="item in columns"
                      :key="item.value"
                      :label="item.lable"
                      :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="subLine" style="width: 100%;" v-if="plateformName == '淘宝'">
            <el-col :span="12">
              <el-form-item label="花呗" style="line-height: 33px;">
                <el-radio-group v-model="dialogSetForm.aliyunPay" @change="tackReviewChange">
                  <el-radio :label="true">开通</el-radio>
                  <el-radio :label="false">未开通</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="六位单号" style="line-height: 33px;">
                <el-input v-model="dialogSetForm.orderNum" size="small"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="subLine" style="width: 100%;">
            <el-col :span="12">
              <el-form-item label="可做单量" style="line-height: 33px;">
                <el-input v-model="dialogSetForm.reciveOrderNum" size="small"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="年龄" style="line-height: 33px;">
                <el-input v-model="dialogSetForm.plateformAge" size="small"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="subLine" style="border-bottom:0 solid #04befe; width: 100%;">
            <el-col :span="24">
              <el-form-item label="地址" style="line-height: 33px;">
                <el-input v-model="dialogSetForm.province" size="small" style="width: 20%"></el-input>
                <el-input v-model="dialogSetForm.city" size="small" style="margin-left: 1%;width: 20%"></el-input>
                <el-input v-model="dialogSetForm.area" size="small" style="margin-left: 1%;width: 20%"></el-input>
                <el-input v-model="dialogSetForm.addressDetail" size="small" style="margin-left: 1%;width: 28%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitSeting()" size="mini" type="primary">提交</el-button>
        <el-button @click="handleSetCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="dialogReviewTitle" :visible.sync="dialogReviewFormVisible">
      <el-form ref="dialogReviewForm" :model="dialogReviewForm" label-width="220px">
        <el-form-item label="审核操作">
          <el-select v-model="dialogReviewForm.reviewStatus" clearable size="mini">
            <el-option
                v-for="item in options"
                :key="item.status"
                :label="item.statusName"
                :value="item.status"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核原因">
          <el-input v-model="dialogReviewForm.reviewBecause" style="width: 50%;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitReviewStatus" size="mini" type="primary">提交</el-button>
        <el-button @click="handleReviewCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 自定义审核dialog -->
    <el-dialog
        :title="dialogSingleReviewTitle"
        :visible.sync="dialogSingleReviewFormVisible"
        width="40%">
      <el-form ref="dialogSingleReviewForm" :model="dialogSingleReviewForm" label-width="180px">
        <el-form-item label="审核原因">
          <el-input v-model="dialogSingleReviewForm.because" style="width: 50%;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitReviewPass" size="mini" type="primary">审核通过</el-button>
        <el-button @click="submitReviewFaill" size="mini" type="primary">审核不通过</el-button>
        <el-button @click="handleSingleReviewCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
import {
  addOrChangeAccountRemarks,
  addOrChangeIdCardRemarks,
  changeAccountUsed, changeBatchIdcardStatus, changeBatchPlateformStatus, changePlateformStatus,
  changeUserUsed, deletedAccountInfo, deletedBatchAccountInfo, getPlateformAccountInfo,
  queryCustomerList,
  queryplateformList, updatePlateformSetting,
  uploadToGrifter
} from "../../api/b2cbusiness/b2c_customerinfo";
import {getStrEndWithNumbers} from "../../lib/utils";
import {getAllShopType} from "../../api/b2cbusiness/b2c_shoptype";
import {queryRoleAccessField} from "@/api/system/sys_role";
import MinxinScroll from "@/components/MinxinScroll";

export default {
  name: "AccountManagelist",
  mixins: [MixinCUD, MinxinScroll],
  data() {
    return {
      tableData: [],
      statusOptions: [
        {
          flag:"202111300003" ,
          value:"审核通过",
        },
        {
          flag: "202111300002" ,
          value:"审核未通过",
        },
        {
          flag: "202111300001" ,
          value:"未审核",
        }
      ],
      queryFormRefName:"queryForm",
      queryForm: {
        userName: '',
        upBusinessUser: '',
        plateformAccountName: '',
        businessUser: '',
        status: '',
        plateformName: ''
      },
      options:[{
        status:"202111300002",
        statusName:"未通过"
      },
        {
          status:"202111300003",
          statusName:"通过"
        }],
      allShopTypes:[],
      dialogReviewFormVisible: false,
      dialogReviewTitle: "批量审核",
      dialogReviewRefName: "dialogReviewForm",
      dialogReviewForm:{
        reviewStatus:"202111300002",
        reviewBecause:"",
      },
      //row审核操作
      dialogSingleReviewFormVisible: false,
      dialogSingleReviewTitle: "批量审核",
      dialogSingleReviewRefName: "dialogSingleReviewForm",
      dialogSingleReviewForm:{
        reviewBecause:"",
      },
      //end
      dialogFormVisible: false,
      dialogTitle: "添加备注",
      dialogRefName: "dialogForm",
      dialogForm: {
        remarks: "",
      },
      dialogSetFormVisible: false,
      dialogSetTitle: "账号设置-试客",
      dialogSetRefName: "dialogSetForm",
      dialogSetForm: {
        diamondsLevel: "",
        accountLeave: ""
      },
      columns: [
        {
          lable: "无",
          value: 0
        },
        {
          lable: "1心",
          value: 4
        },
        {
          lable: "2心",
          value: 11
        },
        {
          lable: "3心",
          value: 41
        },
        {
          lable: "4心",
          value: 91
        },
        {
          lable: "5心",
          value: 151
        },
        {
          lable: "1黄钻",
          value: 251
        },
        {
          lable: "2黄钻",
          value: 501
        },
        {
          lable: "3黄钻",
          value: 1001
        },
        {
          lable: "4黄钻",
          value: 2001
        },
        {
          lable: "5黄钻",
          value: 5001
        },
        {
          lable: "1黄冠",
          value: 10001
        },
        {
          lable: "2黄冠",
          value: 20001
        },
        {
          lable: "3黄冠",
          value: 50001
        },
        {
          lable: "4黄冠",
          value: 100001
        },
        {
          lable: "5黄冠",
          value: 200001
        },
        {
          lable: "1紫冠",
          value: 500001
        },
        {
          lable: "2紫冠",
          value: 1000001
        },
        {
          lable: "3紫冠",
          value: 2000001
        },
        {
          lable: "4紫冠",
          value: 5000001
        },
        {
          lable: "5紫冠",
          value: 10000001
        }
      ],
      plateformName: "",
      tableHeight: 850,
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: null
      },
      scrolltop: null,
      b2cAccessFieldInfos: []
    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 320;
    //console.log(document.body.clientHeight, this.tableHeight)
  },
  computed:{
    isShowAccessField(){
      return function (fieldId) {
        if (this.b2cAccessFieldInfos.length <= 0){
          return false;
        }else{
          return this.b2cAccessFieldInfos.filter(item => item.id == fieldId).length > 0;
        }
      }
    }
  },
  mounted() {
    //this.tableHeight = document.body.clientHeight -220;
    if (this.$route.query.status != undefined && this.$route.query.status != null){
      this.queryForm.status = this.$route.query.status;
    }
    getAllShopType().then(res=>{
      if (res.success){
        this.allShopTypes = res.data;
      }
    });
    this.getData()

    /*获取字段权限*/
    queryRoleAccessField("账号管理", null).then(res => {
      if (res.success){
        this.b2cAccessFieldInfos = res.data;
        //console.log(this.b2cAccessFieldInfos)
      }
    }).catch(err => {
      this.$message({message: err.message, type: 'error'});
    });

    // 监听滚动条的位置
    this.$refs.table.bodyWrapper.addEventListener('scroll', (res) => {
      let height = res.target
      this.scrollTop = height.scrollTop
    },false)
  },
  beforeDestroy() {
    this.$refs.table.bodyWrapper.removeEventListener('scroll', (res) => {
      let height = res.target
      this.scrollTop = height.scrollTop
    },false)
  },
  activated() {
    this.saveScroll()
    this.getData()
  },
  methods: {
    //审核单个
    submitReviewPass(){
      this.dialogSingleReviewForm.accountId = this.dialogSingleReviewForm.plateformId;
      this.dialogSingleReviewForm.status = "审核通过";
        changePlateformStatus(this.dialogSingleReviewForm).then(res=>{
          if (res.success){
            this.$message.success("更新信息成功！");
            this.getData();
            this.handleSingleReviewCloseDialog()
          }
        }).catch(err => {
          this.$message({message: err.message, type: 'error'});
          this.handleSingleReviewCloseDialog()
        });
    },
    submitReviewFaill(){
      this.dialogSingleReviewForm.accountId = this.dialogSingleReviewForm.plateformId;
      this.dialogSingleReviewForm.status = "审核未通过";
      changePlateformStatus(this.dialogSingleReviewForm).then(res=>{
        if (res.success){
          this.$message.success("更新信息成功！");
          this.getData();
          this.handleSingleReviewCloseDialog()
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
        this.handleSingleReviewCloseDialog()
      });
    },
    handleSingleReviewCloseDialog(){
      this.$refs[this.dialogSingleReviewRefName].resetFields();
      this.dialogSingleReviewFormVisible = false;
    },
    // 这里如果直接赋值给this.$el.querySelector('.el-table__body-wrapper').scrollTop会失效，需要加上setTimeout才行。
    saveScroll() {
      this.$nextTick(()=> {
        setTimeout(() => {
          var scrollTop = this.$el.querySelector('.el-table__body-wrapper')
          scrollTop.scrollTop = this.scrollTop
        }, 13)
      })
    },
    statusChange(val){
      this.$forceUpdate()
    },
    handleReviewBatch(){
      this.dialogReviewFormVisible = true;
    },
    handleDeleteBatch(){
      this.$confirm("确定删除当前数据么?").then(_ => {
        deletedBatchAccountInfo(this.multipleSelection).then(res => {
          if (res.success) {
            this.$message.success("删除账户信息成功！");
            this.getData();
          }
        }).catch(err => {
          this.$message({message: err.message, type: 'error'});
        });
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    submitReviewStatus() {
      changeBatchPlateformStatus({plateforAry:this.multipleSelection, reviewInfo:this.dialogReviewForm}).then(res=>{
        if (res.success){
          this.dialogReviewFormVisible = false;
          this.getData();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    handleReviewCloseDialog(){
      this.$refs[this.dialogReviewRefName].resetFields();
      this.dialogReviewFormVisible = false;
    },
    diamondsLevelChange(value){
      console.log(value)
      for (let item = 0; item < this.columns.length; item++){
        if (value > this.columns[item].value && value <= this.columns[item + 1].value){
          if (this.dialogSetForm.diamondsLevel == this.columns[item + 1].value){
            this.dialogSetForm.accountLeave = this.columns[item + 1];
          }else{
            this.dialogSetForm.accountLeave = this.columns[item];
          }
        }
      }
      console.log(this.dialogSetForm.accountLeave)
      this.$forceUpdate()
    },
    selectedChange(value) {
      console.log(value)
      this.dialogSetForm.diamondsLevel = value.value;
      console.log(this.dialogSetForm.accountLeave)
    },
    submitSeting() {
      console.log(this.dialogSetForm)
      updatePlateformSetting(this.dialogSetForm).then(res=>{
        if (res.success){
          this.getData();
          this.$message.success("设置信息成功！");
          this.dialogSetFormVisible = false;
        }
      });
    },
    handleSetCloseDialog() {
      this.$refs[this.dialogSetRefName].resetFields();
      this.dialogSetFormVisible = false;
    },
    settingAccountInfo(index, data) {
      getPlateformAccountInfo(data.plateformId).then(res=>{
        if (res.success){
          this.dialogSetTitle = "账号设置-试客" + data.userName;
          this.plateformName = data.plateformName;
          this.dialogSetFormVisible = true;
          this.dialogSetForm = res.data;
          let ary = res.data.expressAddr.split(',');
          this.dialogSetForm.province = ary[0];
          this.dialogSetForm.city = ary[1];
          this.dialogSetForm.area = ary[2];
        }
      });
    },
    reviewAccountInfo(index, data) {
      this.$router.push({path: "/home/accountdetail", query: {accountId: data.plateformId, userName: data.userName}});
    },
    accountReviewCurrentRow(index, data){
      this.dialogSingleReviewFormVisible = true
      this.dialogSingleReviewForm = {...data}
    },
    addRemarks(index, data) {
      this.dialogForm.accountId = data.plateformId;
      this.dialogFormVisible = true;
    },
    submitRemarks() {
      addOrChangeAccountRemarks(this.dialogForm).then(res => {
        if (res.success) {
          this.dialogFormVisible = false;
          this.$message.success("添加成功")
          this.getData();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    unEnableUser(index, data) {
      changeAccountUsed(data.plateformId).then(res => {
        if (res.success) {
          this.$message.success("账户使用信息修改成功！");
          this.getData();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    deletedAccountInfo(index, data) {
      deletedAccountInfo(data.plateformId).then(res => {
        if (res.success) {
          this.$message.success("删除账户信息成功！");
          this.getData();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    uploadGifter(index, data) {
      uploadToGrifter(data.userId).then(res => {
        if (res.success) {
          this.$message.success("上传骗子库成功！");
          this.getData();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    getStrEndWithNumbers(numbers) {
      return getStrEndWithNumbers(numbers, 8);
    },
    getData() {
      queryplateformList(this.queryForm, this.pagination).then(res => {
        if (res.success) {
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      });
    },
    handlePageSizeChange(val) {
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val) {
      this.pagination.pageNum = val;
      this.submitQueryForm()
      //切换页面恢复到顶部
      this.scrollTop = 0
      this.saveScroll()
    },
    tackReviewChange(val){
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  margin-top: 20px;
  margin-bottom: 20px;
}

.el-form-item {
  margin-bottom: 0;
}

/deep/ .el-dialog__body {
  padding: 10px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}

.tableCls {
  border: 1px solid #04befe;
  border-radius: 5px;
  color: #FFFFFF;
  text-align: center;

  .subLine {
    border-bottom: 1px solid #04befe;
    color: black;
    line-height: 33px;
    text-align: left;
  }

  .leftline {
    border-bottom: 1px solid #04befe;
    border-right: 1px solid #04befe;
    line-height: 33px;
    text-align: left;
  }

  .lineBody {
    border-bottom: 1px solid #04befe;
    color: black;
    text-align: left;
    line-height: 33px;
  }

  i.A {
    width: 20px;
    height: 20px;
    line-height: 20px;
    background-image: url(../../assets/img/A.gif);
    background-position: center center;
    background-repeat: no-repeat;
    display: inline-block;
  }

  i.B {
    width: 20px;
    height: 20px;
    line-height: 20px;
    background-image: url(../../assets/img/B.gif);
    background-position: center center;
    background-repeat: no-repeat;
    display: inline-block;
  }

  i.C {
    width: 20px;
    height: 20px;
    line-height: 20px;
    background-image: url(../../assets/img/C.gif);
    background-position: center center;
    background-repeat: no-repeat;
    display: inline-block;
  }


  i.D {
    width: 20px;
    height: 20px;
    line-height: 20px;
    background-image: url(../../assets/img/D.gif);
    background-position: center center;
    background-repeat: no-repeat;
    display: inline-block;
  }
}
</style>
